import { authApi } from "@api";
import { ComponentBread, ComponentHeader, StyledCreate } from "@components";
import { PATH_COUPON_LIST, PATH_CREATE_COUPON_FAMILY } from "@configs";
import { ICoupon } from "@interfaces";
import { CouponForm } from "@modules";
import { setLoading } from "@redux";
import { useNotify } from "@utils";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";

export const PageCreateCouponFamily = () => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch();
  const { error } = useNotify();
  const { t } = useTranslation();
  const [coupon, setCoupon] = useState<ICoupon>();

  const data = [
    {
      title: <a href={PATH_COUPON_LIST}>{t("page.coupon_management")}</a>,
    },
    {
      title: <a href={"/"}>{t("page.selected_program_name")}</a>,
    },
    {
      title: <a href={PATH_CREATE_COUPON_FAMILY}>{t("page.create_coupon_family")}</a>,
    },
  ];

  useEffect(() => {
    if (id) {
      fetchAdmin();
    }
  }, [id]);

  const fetchAdmin = async () => {
    try {
      dispatch(setLoading(true));
      const res = await authApi.detail(id);
      setCoupon(res.data);
    } catch (err: any) {
      error(t("message.create.fail"));
      dispatch(setLoading(false));
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <>
      <ComponentHeader title={t("page.create_coupon_family")} />
      <StyledCreate>
        <ComponentBread pages={data} />
        <CouponForm coupon={coupon} />
      </StyledCreate>
    </>
  );
};
